import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListLocality from "../Components/Locality/listLocality";
import AddLocality from "../Components/Locality/addLocality";
import EditLocality from "../Components/Locality/editLocality";
import ViewLocality from "../Components/Locality/viewlocality";

const LocalityRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/locality"
        element={<ListLocality></ListLocality>}
      ></Route>
      <Route
        path="/locality/add"
        element={canAdd ? <AddLocality /> : <Navigate to="/locality" replace />}
      ></Route>
      <Route path="/locality/edit/:id" element={canEdit ? <EditLocality /> : <Navigate to="/locality" replace />}></Route>
      <Route path="/locality/view/:id" element={<ViewLocality> </ViewLocality>}></Route>
    </Routes>
  );
};

export default LocalityRoutes;
